
import React, { useCallback } from 'react'
import { useDropzone } from 'react-dropzone'
import { Editor } from "react-draft-wysiwyg";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import Layout from './../../components/Layout/Layout';
export default function ATMLocation(){
    const onDrop = useCallback(acceptedFiles => {
        // Do something with the files
    }, [])
    const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop })

    return(<>
    <Layout title={'Branch & ATM Locator'} current={'/atm/location'} pageTag={'news'}>
        <React.Fragment>
        <main>
                    <div className='py-6'>
                        <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8">
                            <h1 className="text-2xl font-semibold text-gray-900">Push Notification</h1>
                        </div>
                    </div>
                    <div className='max-w-7xl mx-auto px-4 sm:px-6 md:px-8'>
                        <div className='py-4'>
                            <div className="flex">

                                <div className="flex-auto w-64">
                                    <section aria-labelledby="primary-heading" className="min-w-0 flex-1 h-full flex flex-col lg:order-last">
                                        <label htmlFor="email" className="block text-sm font-medium text-gray-700">
                                            Description/Address
                                        </label>
                                        <div className="mt-1">
                                            <input
                                                type="text"
                                                name="text"
                                                id="text"
                                                className="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md"
                                                placeholder="you@example.com"
                                            />
                                        </div>
                                        <label htmlFor="email" className="mt-5 block text-sm font-medium text-gray-700">
                                            Content
                                        </label>
                                        <div className="block border-1 bg-gray-300 border-gray-300 rounded h-full w-full text-dark">
                                            <Editor
                                                toolbarClassName="toolbarClassName"
                                                wrapperClassName="wrapperClassName"
                                                editorClassName="editorClassName"
                                            />
                                        </div>
                                        <div className='flex justify-end'>
                                            <div className="flex ml-2 py-3  ">
                                                <button
                                                    type="button"
                                                    className="w-35  mr-3 btn-secondary border border-dark inline-flex items-center justify-center rounded-md   px-4 py-2 text-sm font-medium text-dark shadow-sm sm:w-auto"
                                                >
                                                    Reset Page
                                                </button>
                                                <button
                                                    type="button"
                                                    className="w-35inline-flex items-center justify-center rounded-md border border-transparent btn-primary px-4 py-2 text-sm font-medium text-white shadow-sm  sm:w-auto"
                                                >
                                                    Send Notifications
                                                </button>

                                            </div>
                                        </div>
                                    </section>
                                </div>
                                <div className="flex-auto w-12 ">
                                    <aside className=" w-80 bg-white  border-gray-200 overflow-y-auto lg:block">
                                        <div className="h-full">
                                            <div className="p-6 h-full">
                                                                                           <div className="block border-1 mt-2 bg-gray-300 rounded-xl rounded h-full w-full ">
                                                    <div className="p-6">
                                                        <div className="bg-white">
                                                            <div className="flex ml-2 py-3">
                                                                <button
                                                                    type="button"
                                                                    className="w-35 mr-3 inline-flex items-center justify-center rounded-md border border-transparent btn-primary px-4 py-2 text-sm font-medium text-white shadow-sm  sm:w-auto"
                                                                >
                                                                    New Upload
                                                                </button>
                                                                <button
                                                                    type="button"
                                                                    className="w-35 inline-flex items-center justify-center rounded-md border border-transparent  px-4 py-2 text-sm font-medium text-dark shadow-sm sm:w-auto"
                                                                >
                                                                    Recent
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="bg-gray-100 p-6">
                                                        <div {...getRootProps()}>
                                                            <input {...getInputProps()} />
                                                            {
                                                                isDragActive ?

                                                                    <p>Drop the files here ...</p> :
                                                                    <p className='border border-dashed text-center'>Click to browser</p>
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </aside>
                                </div>
                            </div>

                        </div>
                    </div>
                </main>
        </React.Fragment>
        </Layout></>)
}